import {
  Component,
  ElementRef,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { TasksService } from "src/app/_services/tasks.service";

import moment from "moment-timezone";
import { UtilServiceService } from "src/app/_services/utilService/util-service.service";
import { CustomersService } from "src/app/_services/customers.service";
import { ErrorUtil } from "src/app/_utilities/error";

import * as _ from "lodash";
import { AuthenticationService } from "src/app/auth/authentication.service";
import { PermissionService } from "src/app/auth/permission.service";
import { SubscriptionUtil } from "src/app/_utilities/subscription";
import { Router } from "@angular/router";
import { BsModalRef } from "ngx-bootstrap/modal";
import { ModalServiceService } from "src/app/_services/modal-service.service";
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { Calendar } from "primeng/calendar";
import { UsersService } from "src/app/_services/admin/users.service";


declare var google: any;


@Component({
    selector: 'app-add-edit-task-lite',
    templateUrl: './add-edit-task-lite.component.html',
    styleUrls: ['./add-edit-task-lite.component.scss'],
    standalone: false
})
export class AddEditTaskLiteComponent extends SubscriptionUtil implements OnInit, OnDestroy {
  
public addTaskFullForm!: UntypedFormGroup;
  public addTask: any = {
    taskName: null,
    description: null,
   joName: null,
    duration: "30",
    jobOrder: { id: null },
    date: new Date(),
    startTime: new Date(),
    endTime: new Date(),
    checklistRecordId: null,
   };

  submitTouched: boolean = false;

  public mode!: string;

  comingFrom: string = "Task";

 data: any;
  addonFeature: any;

  
  @ViewChild('calendar') calendar: Calendar;
  @ViewChild('starTime') starTime: Calendar;
  @ViewChild('endTime') endTime: Calendar;
  taskAITime: any= {
    displayAITime: null,
    digitalTime: null,
    newTime: null
  };
  dateConfig: any;
  timezone: any;
  private formData: any;
  translate: any;
  timeFirstSet: boolean = false;
  
  constructor(
    private tasksService: TasksService,
    private util: UtilServiceService,
    private errorUtil: ErrorUtil,
    private auth: AuthenticationService,
    private perm: PermissionService,
    private router: Router,
    public modalRef: BsModalRef,
    private modalService: ModalServiceService,
    private languageTranslateService: LanguageTranslateService,
  ) {
    super();
    this.getLanguageData();
    this.preInit();
  }

  ngOnInit(): void {
    this.init();
  }

  /******************************************** pre init ******************************************/
    private preInit() {
      this.addTaskFullForm = new UntypedFormGroup({
        name: new UntypedFormControl(null, [Validators.required]),
        startTime: new UntypedFormControl(null, [Validators.required]),
        endTime: new UntypedFormControl(null, [Validators.required]),
        date: new UntypedFormControl(null, [Validators.required]),
        description: new UntypedFormControl(null),
        
      });
      
    }
    
  
    private init() {
      
      this.addonFeature = this.auth.getAddonFeatureLists();
  
    
      this.dateConfig = { dateInputFormat: localStorage.getItem("date_format")!.toUpperCase() };
  
      this.timezone = this.auth.getUserTimezone();
     
      // to know if open from jo order
      if (this.data.comingFrom !== undefined && this.data.comingFrom == "JO") {
        this.comingFrom = "JO";
      }
      if (this.data.checklistRecordId ) {
        
        this.addTask.checklistRecordId = this.data.checklistRecordId;
      }
  
  
      if (this.mode === "edit") {
        this.addTask = this.data;
            this.tasksService.getTaskById(this.data.id).subscribe((task: any) => {
            
            if (!this.addTask.jobOrder) {
              this.addTask.jobOrder = { id: null };
            }
      
          
            var formatDate = moment .tz(this.addTask.startDateTime, this.auth.getUserTimezone()).toISOString();
      
            this.addTask.date = new Date(formatDate);
            if (this.addTask.startTime && this.addTask.endTime) {
                var finalStartTime = this.util.timeFormatter( this.addTask.startTime, this.addTask.date );
                var finalEndTime = this.util.timeFormatter( this.addTask.endTime,this.addTask.date );
                this.addTask.startTime = moment(this.addTask.startDateTime)
                  .tz(this.auth.getUserTimezone())
                  .format("hh:mm A");
                this.addTask.endTime = moment(this.addTask.endDateTime).tz(this.auth.getUserTimezone())
                  .format("hh:mm A");
              } else {
                this.addTask.startTime = moment(this.addTask.startDateTime)
                  .tz(this.auth.getUserTimezone())
                  .format("hh:mm A");
                this.addTask.endTime = moment(this.addTask.endDateTime)
                  .tz(this.auth.getUserTimezone())
                  .format("hh:mm A");
              }
          })
      
      } else if (this.mode === "add") {
        this.timeFirstSet = true
        if (this.data.checkListRecordId ) {
          this.addTask.checklistRecordId = this.data.checkListRecordId;
        }
    
        this.addTask.date = new Date();
        this.setStartTime();
        if (this.data.comingFrom !== undefined && this.data.comingFrom == "JO") {
          this.comingFrom = "JO";
          }
      
  
        if (this.data.comingFrom = "JO") {
          this.addTask.jobOrder = this.data;
          this.addTask.taskName = this.addTask.jobOrder.jobOrderNumber;
          
          if ( this.addTask.jobOrder.installationDate && this.addTask.jobOrder.installationDate !== "" )
            this.addTask.date = new Date(this.addTask.jobOrder.installationDate);
  
          if (this.addTask.jobOrder.installationTime && this.addTask.jobOrder.installationTime !== "" )
            this.addTask.startTime = moment(
              this.addTask.jobOrder.installationTime
            ).format("h:mm A");
          else this.setStartTime(); 
        }
      
  
        this.changeEndTime();
      }
  
      if(this.mode == "add" && this.data.taskTemplateId)
      {
        this.gettaskTemplate(this.data.taskTemplateId)
      }
  
      // if (this.assignMethod) {
      //   this.task.assignMethod = this.assignMethod;
      // }
  
      // null select
      const nullSelect = [
        {
          id: null,
          name: "Select",
          priority: "null",
        },
      ];
  
     setTimeout(() => {
      this.timeFirstSet = true;
    }, 500);
      // this.setJOFunction();
      // this.selectJOFunction();
  
     
    }
  
    /******************************************** lock time ******************************************/
    public toggleFixed(val: any) {
      this.addTask.fixed = val;
    }
  
    /******************************************** change end time when start time adjusted ******************************************/
    public changeEndTime() {
      if (!this.data.taskTemplateId && this.timeFirstSet) {
        if (this.mode == "add" || this.mode == "add&back") {
          setTimeout(() => {
            const start = moment(this.addTask.startTime, "h:mm A").format("H:mm");
            const endTime = moment(
              moment().format("YYYY-MM-DD") + " " + start
            ).add(60, "minutes");
            this.addTask.endTime = endTime.toDate();
          }, 500);
        } else {
          setTimeout(() => {
            const difference = this.util.durationFormatter(
              this.addTask.startDateTime,
              this.addTask.endDateTime
            );
            const differenceSplit = difference.split(" ");
            if (differenceSplit.length == 2) {
              if (differenceSplit[1] == "hour" || differenceSplit[1] == "hours") {
                var hrs: any = differenceSplit[0];
                var mins: any = 0;
              } else {
                var hrs: any = 0;
                var mins: any = differenceSplit[0];
              }
            } else {
              var hrs: any = differenceSplit[0];
              var mins: any = differenceSplit[2];
            }
            const start = moment(this.addTask.startTime, "h:mm A").format("H:mm");
            let endTime = moment(moment().format("YYYY-MM-DD") + " " + start).add(
              { hours: hrs, minutes: mins }
            );
            this.addTask.endTime = endTime.toDate();
          }, 1000);
        }
      }
    }
  
  
    public onSubmit() {
      this.submitTouched = true;
  
      // validation form
      if (!this.addTaskFullForm.valid) {
        for (var i in this.addTaskFullForm.controls) {
          this.addTaskFullForm.controls[i].markAsTouched();
        }
        this.submitTouched = false;
        return false;
      }
  
      // validation for end time after start time
      let date = moment(
        this.addTask.date,
        this.dateConfig.dateInputFormat
      ).format("YYYY-MM-DD");
  
      let startTime = null;
      let endTime = null;
       
        const stime = moment(this.addTask.startTime, "h:mm A").format("H:mm");
        var startDateTime = moment( moment(this.addTask.date).format("YYYY-MM-DD") + " " + stime);
        var pickUpStartTimeData: any = moment.tz( startDateTime, this.auth.getUserTimezone() );
        var finalStartTime2: any = pickUpStartTimeData.toDate();
        const etime = moment(this.addTask.endTime, "h:mm A").format("H:mm");
        var endDateTime = moment( moment(this.addTask.date).format("YYYY-MM-DD") + " " + etime );
        var pickUpStartTimeData: any = moment.tz(endDateTime,this.auth.getUserTimezone() );
        var finalEndTime2: any = pickUpStartTimeData.toDate();
  
        var finalStartTime: any = this.util.timeFormatter(stime, date);

        if (endDateTime.isBefore(startDateTime)) {
          //end time is crossing the next day. So, take the next day date as 'date' variable. 
          //Update the 'date' here
          date = moment(
            this.addTask.date,
            this.dateConfig.dateInputFormat,
          ).add(1, "day").format("YYYY-MM-DD");
          //update the endDateTime and realted variables
          endDateTime = moment( date + " " + etime );
          pickUpStartTimeData = moment.tz(endDateTime,this.auth.getUserTimezone() );
          finalEndTime2 = pickUpStartTimeData.toDate();
        }

        var finalEndTime  : any= this.util.timeFormatter(etime, date);  
        this.formData = {
          assignStatus: this.addTask.assignStatus,
          description: this.addTask.description,
          endDateTime: finalEndTime,
          endDateTime2: finalEndTime2,
          location: this.addTask.location,
          locationName: this.addTask.locationName,
          latitude: this.addTask.latitude,
          longitude: this.addTask.longitude,
          startDateTime: finalStartTime,
          startDateTime2: finalStartTime2,
          taskName: this.addTask.taskName,
          taskStatus: this.addTask.taskStatus,
          placeId: this.addTask.placeId,
          comingFrom: this.comingFrom,
          checklistRecordId:this.addTask.checklistRecordId ?? null,
          taskNumber: this.addTask.taskNumber,
           assignedUsersList: [
            { owner: true, assignedTo: { id: this.auth.getUserId() } },
          ],
          
        };

        if (this.addTask.jobOrder && this.addTask.jobOrder.id ) {
          this.formData.jobOrder = { id: this.addTask.jobOrder.id };
          this.formData.joName = this.addTask.jobOrder.jobOrderNumber;
        }
       
        if (this.addTask.description && (this.addTask.description === "" || this.addTask.description.length === 0)) {
          this.addTask.description = null;
        }
        if(this.addTask.tmplTaskId){
          this.formData.tmplTaskId = this.addTask.tmplTaskId;
        }
  
        if (this.mode === "edit" ) {
          this.formData.id = this.data.id;
          this.formData.taskNumber=this.data.taskNumber
          if (this.addTask.procedureId){
            this.formData.procedureId = this.addTask.procedureId
          }
  
          this.tasksService.editTask(this.formData).subscribe((taskRes: any) => {
            //console.log("Response ", res);
            if (taskRes.status === 200 || taskRes.status === 201) {
              let req = {
                routeDate: date,
                isOptimized: false,
                user: {
                  id: this.auth.getUserId(),
                },
              };
  
              this.tasksService.createRouteOptimization(req).subscribe((res: any) => {
                  //console.log("Response ", res);
                  if (res.status === 200 || res.status === 201) {
                    this.modalRef.hide();
                    this.errorUtil.setErrorMessage(200, null, this.translate?.general.messages.updatedSuccessfully,"success", 3000);  
                  } else {
  
                    var errorTitle = res.error.title
                    if (res.error.type == 'dynamic-lang-error') {
                      var data = res.error.instance + ".validationBE." + res.error.detail;
                      var message = this.languageTranslateService.getNestedValue(this.translate, data);
                      errorTitle = message
                    }
          
                    this.errorUtil.setErrorMessage(
                      res.status,
                      null,
                      errorTitle,
                      "error",
                      2000
                    );
                  }
                },(err) => {
                  //this.spinner.hide()
                 const title = this.errorUtil.processErrorTitle(err.error,this.translate)
                 this.errorUtil.setErrorMessage(err.status, null ,  title, 'error',3000);
                 this.submitTouched = false;
              });
              }
              else {
  
                var errorTitle = taskRes.error.title
                if (taskRes.error.type == 'dynamic-lang-error') {
                  var data = taskRes.error.instance + ".validationBE." + taskRes.error.detail;
                  var message = this.languageTranslateService.getNestedValue(this.translate, data);
                  errorTitle = message
                }
      
                this.errorUtil.setErrorMessage(
                  taskRes.status,
                  null,
                  errorTitle,
                  "error",
                  2000
                );
              }
              
            }, (err) => {
             // this.spinner.hide()
             const title = this.errorUtil.processErrorTitle(err.error,this.translate)
             this.errorUtil.setErrorMessage(err.status, null ,  title, 'error',3000);
             this.submitTouched = false;
          });
  
        } else if (this.mode === "add") {
          this.tasksService.createTask(this.formData).subscribe((taskRes: any) => {
              if (taskRes.status === 200 || taskRes.status === 201) {
               this.modalRef.hide();
                this.submitTouched = false;
  
                this.util.openTaskVIewPage(taskRes.body.id);
              } else {
  
                var errorTitle = taskRes.error.title
                if (taskRes.error.type == 'dynamic-lang-error') {
                  var data = taskRes.error.instance + ".validationBE." + taskRes.error.detail;
                  var message = this.languageTranslateService.getNestedValue(this.translate, data);
                  errorTitle = message
                }
      
                this.errorUtil.setErrorMessage(
                  taskRes.status,
                  null,
                  errorTitle,
                  "error",
                  2000
                );
              }
            }, (err) => {
              //this.spinner.hide()
             const title = this.errorUtil.processErrorTitle(err.error,this.translate)
             this.errorUtil.setErrorMessage(err.status, null ,  title, 'error',3000);
             //this.submitTouched = false;
          });
        }
  
        // for smart assign
      
    }
  
    public openModal(modalView: string, data: any) {
     // data.Id = this.jobOrderId;
      if (modalView == "addTaskQuick") {
        data.comingFrom = "JO";
      }
  
      this.modalService.openModal(modalView, data);
    }
  
    /********************************************************* Set Time  ********************************************************/
    setStartTime() {
      if (!this.addTask.adhoc) {
        const start = moment();
        const remainder = 30 - (start.minute() % 30);
       
        const start2 = moment(start, "h:mm A").format("H:mm");
        const startTime = moment(
          moment().format("YYYY-MM-DD") + " " + start2
        ).add(remainder, "minutes");
        this.addTask.startTime = startTime.toDate();
  
        const endTime = moment(moment().format("YYYY-MM-DD") + " " + start2).add(
          60,
          "minutes"
        );
        this.addTask.endTime = endTime.toDate();
      } else {
        const start = moment();
        // const start = moment().add(1, 'h');
        const remainder = 5 - (start.minute() % 5);
        
        const start2 = moment(start, "h:mm A").format("H:mm");
        const startTime = moment(
          moment().format("YYYY-MM-DD") + " " + start2
        ).add(remainder, "minutes");
        this.addTask.startTime = startTime.toDate();
  
        const endTime = moment(moment().format("YYYY-MM-DD") + " " + start2).add(
          60,
          "minutes"
        );
        this.addTask.endTime = endTime.toDate();
        
      }
    }
  /********************************************************* Get Language Data  ********************************************************/
    getLanguageData() {
      this.push(this.languageTranslateService.wordSrc$.subscribe(data => { 
        if(Object.keys(data).length != 0){
          this.translate = data
        }
      }))
      //this.mainLabel = this.translate?.site.label.plural
    }
  
    push(obs: any) {
      super.push(obs);
    }

    openCalendar() {
      this.calendar.inputfieldViewChild.nativeElement.click();
    }
    openStarTime() {
      this.starTime.inputfieldViewChild.nativeElement.click();
    }
    openEndTime() {
      this.endTime.inputfieldViewChild.nativeElement.click();
    }
  
   
  
    ngOnDestroy(): void {
      super.ngOnDestroy();
    }
  /******************************************** Auto populate template data  ******************************************/
    gettaskTemplate(taskTemplateId) {
  
      this.tasksService.getTaskTemplate(taskTemplateId).subscribe((res: any) => {
        const tamplateData = res.body
        this.addTask.tmplTaskId = taskTemplateId
        this.addTask.taskName = tamplateData.taskName
        this.addTask.jobOrder = this.data.jobOrder;
  
        if (tamplateData.copyDateFromJobOrder && this.data.comingFrom === "JO") {
          this.addTask.date = new Date(this.data.jobOrder.installationDate);
          //this.addTaskFullForm.get('date').disable();
      } else if (tamplateData.date >= 0) {
          const tomorrow = new Date();
          if (tamplateData.date >= 1) {
              tomorrow.setDate(tomorrow.getDate() + tamplateData.date);
          }
          this.addTask.date = tomorrow;
          //this.addTaskFullForm.get('date').disable();
      }
  
  
      // 
  
  
      if (tamplateData.startTime) {
        const selectedDate = this.addTask.date;
        const today = new Date();
        
        if (tamplateData.copyDateFromJobOrder && 
            this.data.comingFrom === "JO" && 
            selectedDate.toDateString() === today.toDateString()) {
            // If it's today, set to current time + 1 hour
            const currentTime = new Date();
            currentTime.setHours(currentTime.getHours() + 1);
            this.addTask.startTime = currentTime;
        } else {
            // For future dates or non-JO cases, use template time
            const [hours, minutes, seconds] = tamplateData.startTime.split(':').map(Number);
            const date = new Date();
            date.setHours(hours);
            date.setMinutes(minutes);
            date.setSeconds(seconds);
            this.addTask.startTime = date;
        }
        
        //this.addTaskFullForm.get('startTime').disable();
    }
  
  
        if (tamplateData.duration && tamplateData.duration > 1) {
          const newTime = moment(this.addTask.startTime).add(tamplateData.duration, 'minutes').toDate();
          this.addTask.endTime = newTime
          //this.addTaskFullForm.get('endTime').disable();
        }
        
        if (tamplateData.description) {
          this.addTask.description = tamplateData.description
        }
      
        if (tamplateData.taskStatus) {
          this.addTask.taskStatus = tamplateData.taskStatus;
        }
  
  
  
      });
    }

}
